import React from 'react';
import {Link} from 'react-router-dom';

import './index.style.less';
import PropTypes from 'prop-types';
import {useSidebarContext} from '../../../../utility/AppContextProvider/SidebarContextProvider';

const AppLogo = ({hasSidebarColor}) => {
  const {sidebarColorSet} = useSidebarContext();
  return (
    <div className='app-logo'>
      {hasSidebarColor && sidebarColorSet.mode === 'dark' ? (
        <Link to='/'>
          <img src='/assets/images/logo-white-with-name.png' alt='phr-logo' />
        </Link>
      ) : (
        <Link to='/'>
          <img src='/assets/images/logo-with-name.png' alt='phr-logo' />
        </Link>
      )}
    </div>
  );
};

export default AppLogo;

AppLogo.propTypes = {
  hasSidebarColor: PropTypes.bool,
};
